import type { AsyncTaskStartResponse } from "@/composables/useAsyncTask";
import { goSolidApi } from "@/composables/useGoSolidApi";
import { IssuanceDataSource } from "@/dashboard/production_strategy/issuance-reporting/issuanceStatusUtils";
import type {
  AdminIssuanceProductionDataResponse,
  CompanyRecords,
  FetchFromGrexelResponse,
  LtPowerBiBulkUploadResponse,
} from "./types";

export async function uploadPowerBiFile(
  file: File
): Promise<LtPowerBiBulkUploadResponse> {
  const formData = new FormData();
  formData.append("file", file);

  const response = await goSolidApi.post(
    "/api/admin/issuance-reporting/lt/power-bi/upload",
    formData
  );

  return response.data;
}

export async function getIssuanceDataByMonth(
  year: number,
  month: number,
  status?: string
): Promise<AdminIssuanceProductionDataResponse> {
  const params = new URLSearchParams();
  params.append("year", year.toString());
  params.append("month", month.toString());
  params.append("data_source", IssuanceDataSource.LT_ESO);
  if (status) {
    params.append("status", status);
  }

  const response = await goSolidApi.get(
    `/api/admin/issuance-reporting/issuance-production-data?${params.toString()}`
  );

  return response.data;
}

export async function sendToGrexel(
  companyRecords: CompanyRecords[]
): Promise<AsyncTaskStartResponse> {
  const response = await goSolidApi.post(
    "/api/admin/issuance-reporting/lt/send-to-grexel",
    {
      company_records: companyRecords,
    }
  );

  return response.data;
}

export async function fetchFromGrexel(
  year: number,
  month: number
): Promise<FetchFromGrexelResponse> {
  const response = await goSolidApi.post(
    "/api/admin/issuance-reporting/lt/fetch-from-grexel",
    {
      year,
      month,
    }
  );

  return response.data;
}
